import { render, staticRenderFns } from "./HelpFun.vue?vue&type=template&id=4f5abaf2&scoped=true"
import script from "./HelpFun.vue?vue&type=script&lang=js"
export * from "./HelpFun.vue?vue&type=script&lang=js"
import style0 from "./HelpFun.vue?vue&type=style&index=0&id=4f5abaf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5abaf2",
  null
  
)

export default component.exports